module.exports = __webpack_public_path__ + "static/media/blue_expansion.5f60cd7e.svg";